export const sleep = time => new Promise(res => setTimeout(res, time * 1000));
/**
 * Generates a transparent PNG File of the given dimensions using Canvas API.
 * Used as a dummy primary asset when a video is uploaded as the primary input.
 * If your ad server rejects transparent PNGs, swap clearRect for a solid fill.
 */
export const generateDummyBanner = (
  width: number,
  height: number,
): Promise<File> => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const specialWidths = [1627, 1628, 1630];
    canvas.width = specialWidths.includes(width) ? 1629 : width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return reject(new Error('Canvas 2D context not supported'));
    }

    // Transparent placeholder — swap below lines if ad server needs opaque
    ctx.clearRect(0, 0, width, height);

    // Uncomment for solid black dummy instead:
    // ctx.fillStyle = '#000000';
    // ctx.fillRect(0, 0, width, height);

    canvas.toBlob(blob => {
      if (!blob) {
        return reject(new Error('Failed to generate canvas blob'));
      }
      const file = new File([blob], `dummy_banner_${width}x${height}.png`, {
        type: 'image/png',
      });
      resolve(file);
    }, 'image/png');
  });
};
